import {
  createFrontendModule,
  ApiBlueprint,
  discoveryApiRef,
  oauthRequestApiRef,
} from '@backstage/frontend-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { oidcAuthApiRef } from './oidcAuthApi';

/**
 * Extension that registers the OIDC OAuth2 API (Microsoft Entra ID).
 *
 * Uses Backstage's built-in OAuth2 class, which handles the full
 * sign-in popup + token exchange flow via /api/auth/oidc/start.
 * discoveryApi resolves the base URL; oauthRequestApi manages the
 * popup lifecycle and pending-request queuing.
 */
const oidcAuthApi = ApiBlueprint.make({
  name: 'oidc',
  params: defineParams =>
    defineParams({
      api: oidcAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi }) =>
        OAuth2.create({
          discoveryApi,
          oauthRequestApi,
          provider: {
            id: 'oidc',
            title: 'Microsoft Entra ID',
            icon: () => null,
          },
          defaultScopes: ['openid', 'email', 'profile', 'offline_access'],
          environment: process.env.NODE_ENV,
        }),
    }),
});

/**
 * Frontend module that wires the OIDC API extension into the `app` plugin.
 *
 * pluginId must be 'app' so the module is applied to the app plugin
 * (where signInModule also lives). Using 'auth' would target the
 * @backstage/plugin-auth plugin, which is not present here.
 */
export const oidcAuthModule = createFrontendModule({
  pluginId: 'app',
  extensions: [oidcAuthApi],
});
